// Install the global [data-rp-intent-trigger] click recorder before any
// other init runs, so lazily-loaded facades (e.g. shopping-agent) can detect
// pre-load CTA clicks. Mirrors the require in webstore-main.js so legacy
// bundle visitors get the same pre-load capture window.
require('public/js/lib/intents');

const THE_SCRIPT = function () {
	const onReady = require('public/js/deps/main-legacy');
	onReady();
};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	if (typeof __CURRENT_SCRIPT__ === 'undefined') {
		throw new Error('__CURRENT_SCRIPT__ is not defined');
	}
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
